import { call, put, takeLatest } from "redux-saga/effects";
import { _BROTHER_PLUS_API_ENDPOINTS, LOCALSESSIONDATAKEYS, SUCCESS } from "../../../constants/AppConstants";
import i18next from "i18next";
import { handleError } from "../../SagaError";
import { getLocalSessionData } from "../../../utils/Authentication/handleUserSession";
import { _CALLPUTAPI } from "../../../api/apiHandler";
import { UpdateUserNotificationsServiceFailure, UpdateUserNotificationsServiceInit, UpdateUserNotificationsServiceSuccess } from "./UpdateNotificationSlice";

function __UPDATEUSERNOTIFICATIONSERVICE(msgID) {
    const UID = getLocalSessionData(LOCALSESSIONDATAKEYS.UID);
    const endpoint = _BROTHER_PLUS_API_ENDPOINTS.UPDATE_USER_NOTIFICATIONS;
    const payload = {
        userId: UID,
        messageId: msgID
    }
    return _CALLPUTAPI(endpoint, payload)
    .then(response => response)
    .catch(error => { throw error; });
}

function* handleUpdateNotificationService(action) {
  try {
    const  msgID = action.payload 
    const notificationData = yield call(__UPDATEUSERNOTIFICATIONSERVICE, msgID);
    (notificationData.actionStatus.toUpperCase() === SUCCESS)
      ? yield put(UpdateUserNotificationsServiceSuccess(notificationData))
      : yield* handleError(UpdateUserNotificationsServiceFailure, i18next.t("ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR"));
  } catch (error) {
    yield* handleError(UpdateUserNotificationsServiceFailure, error.message);
  }
}

export default function* watchUpdateUserNotificationsService() {
  yield takeLatest(UpdateUserNotificationsServiceInit.type, handleUpdateNotificationService);
}

